import { APIDataRoomMessage, APIMetaDataRoomMessagePropertyNames } from '@evertel/types'
import { Store } from '@evertel/types'
import { decorate, injectable } from '@evertel/di'

export interface DisplayRoomMessage extends APIDataRoomMessage {
    prevMessageDate?: Date
    prevOwnerId?: number
    dateChanged?: boolean
    window?: 'primary' | 'anchor'
    meta?: {
        repliesSubscription?: {
            notify: boolean | null
        }
        [key: string]: any
    }
}

class RoomMessagesStore extends Store<DisplayRoomMessage> {
    constructor() {
        super([...APIMetaDataRoomMessagePropertyNames, 'media', 'reactions', 'prevMessageDate', 'prevOwnerId', 'dateChanged', 'window'])
    }
}

decorate(injectable(), RoomMessagesStore)

export { RoomMessagesStore }
